// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1516227481833
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./components/content/content.scss
// module id = 89
// module chunks = 0